var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[..._vm.sizeCss, _vm.css, _vm.shadowCss, 'bg-white rounded-md']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }